import { defineRoute } from '../../api-routes/new-helpers'
import { FeedbackDTO } from '../../dtos/feedback'
import { ResponseData } from '../../dtos/generic'
import { adminControllerPath } from './admin'

export const adminPromptTemplatesControllerPath = adminControllerPath + 'prompt-templates/'

export const adminFeedbacksControllerPath = adminControllerPath + 'feedbacks/'

export const AdminFeedbacksRoutes = {
  getAll: defineRoute<'GET', ResponseData<FeedbackDTO[]>>({
    path: adminFeedbacksControllerPath,
  }),
}
